/**
 * Identity Server Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CredentialViewModel } from './credentialViewModel';
import { AttestationModel } from './attestationModel';
import { BackupViewModel } from './backupViewModel';


export interface FidoAuthMethodViewModelAllOf { 
    credentials?: Array<CredentialViewModel> | null;
    attestations?: Array<AttestationModel> | null;
    backup?: BackupViewModel;
}

